import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { CARE_PLAN_MAX_ACTIVE_GOALS } from '../../care-plan.model';
import { CarePlanStore } from '../../care-plan.store';

/**
 * Up to 3 active-goal pills + linked-case counts, and a "Manage goals" link.
 * Manage goals opens `ManageGoalsDialogComponent` (wired in Phase 4).
 */
@Component({
  selector: 'bn-goals-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './goals-bar.component.html',
  styleUrl: './goals-bar.component.scss',
})
export class GoalsBarComponent {
  protected readonly store = inject(CarePlanStore);
  protected readonly maxActiveGoals = CARE_PLAN_MAX_ACTIVE_GOALS;

  readonly manageGoals = output<void>();

  linkedCaseCount(goalId: string): number {
    return this.store.goals().find((g) => g.id === goalId)?.linkedCaseIds.length ?? 0;
  }
}
